import React, { useContext, useRef } from 'react';
import { AppContext } from 'src/components/app-context';
import { ButtonSize, ButtonType } from '@prisjakt/ui/button';
import { trackPriceListFilterUpdate } from '../tracking';
import { useOfferListFilterContext } from '../offer-list-filter-context';
import { FilterType, IFilter } from 'src/components/price-list/types';
import { getConditionName, resetVariantFilters } from './utils';
import { IProductCondition, IProductConditionsProps } from './types';
import { ButtonWrapper, ConditionHeader, StyledToggleButton } from './styles';
import { TitleMediumText } from '@prisjakt/ui/text/variants';

export const ProductConditions: React.FC<React.PropsWithChildren<
  IProductConditionsProps
>> = props => {
  const { values, showTitle, isMobile } = props;
  const {
    getFilter,
    getActiveFilters,
    updateMultipleFilters,
  } = useOfferListFilterContext();
  const { t } = useContext(AppContext);
  const instanceId = useRef(Math.random()); // Since this is used inside media queries, we get aria failiures on non-unique keys without this

  const conditionFilter = getFilter(FilterType.CONDITION);

  const selectedCondition: string = conditionFilter?.selection?.length
    ? conditionFilter?.selection[0]
    : 'new';

  const handleSelectedCondition = (cond: IProductCondition) => {
    if (cond.name !== selectedCondition) {
      trackPriceListFilterUpdate(cond.name, false);
      const updatedConditionFilter = {
        ...conditionFilter,
        active: true,
        selection: [cond.name],
      } as IFilter;
      const updatedVariantFilters = resetVariantFilters(getActiveFilters());
      updateMultipleFilters([...updatedVariantFilters, updatedConditionFilter]);
    }
  };

  if (values.length <= 1) {
    return null;
  }

  return (
    <>
      {showTitle() && (
        <ConditionHeader>
          <TitleMediumText>
            {t('product', 'price-filter.condition-title')}
          </TitleMediumText>
        </ConditionHeader>
      )}
      <ButtonWrapper>
        {values.map(condition => {
          const key = `${condition.name}-${instanceId.current}`;
          const name = getConditionName(condition.name, t);

          return (
            <StyledToggleButton
              key={key}
              onClick={() => handleSelectedCondition(condition)}
              selected={condition.name === selectedCondition}
              ariaLabel={name}
              type={ButtonType.OUTLINED}
              size={isMobile ? ButtonSize.NORMAL : ButtonSize.SMALL}
            >
              {name}
            </StyledToggleButton>
          );
        })}
      </ButtonWrapper>
    </>
  );
};
